export interface SitesBuilderBrizyGetDto {
  url: string;
}
